import * as React from "react";
import Button from "@mui/material/Button";
import { Basket } from "../../../context/basket";
import { useContext, useEffect } from "react";
import { useRouter } from 'next/navigation';
import updateSubscription from '../elements/actions/updateSubscription';

const Checkout = (props) =>
{
    const setLoader = props.setLoader;
    const setLoadingMessage = props.setLoadingMessage;
    const [checkoutMethod, setCheckoutMethod] = React.useState('checkout');
    const { push, refresh } = useRouter();
    const basket = useContext(Basket);
    let basketData = basket?.data?.quote?.quote;
    const [disabled, setDisabled] = React.useState(true);

    const checkout = () => {
        if (checkoutMethod === 'shopify_entrant') {
            setLoader(true);
            setLoadingMessage('Loading account...');
            setTimeout(function () {
                window.location.href = '/account';
                push('/account');
                refresh();
            }, 1000);
        } else if (checkoutMethod === 'shopify_entrant_no_consult') {
            const basketData = basket?.data?.quote?.quote;
            let beardConsultation = false;
            if (basketData.items) {
                for (let i = 0; i < basketData.items.length; i++) {
                    let product = basketData.items[i];
                    let beardBooster = product.product_name.includes('Beard');
                    if (beardBooster) {
                        beardConsultation = true;
                        break;
                    }
                }
            }

            setLoader(true);
            setLoadingMessage('Loading consultation...');
            setTimeout(function () {
                if (beardConsultation) {
                    window.location.href = 'https://sons.co.uk/pages/consultation-beard';
                    push('https://sons.co.uk/pages/consultation-beard');
                } else {
                    window.location.href = 'https://sons.co.uk/pages/consultation-hair';
                    push('https://sons.co.uk/pages/consultation-hair');
                }
                refresh();
            }, 1000);
        } else if (checkoutMethod === 'update') {
            setLoader(true);
            setLoadingMessage('Updating your subscription, please wait...');
            updateSubscription().then(response => {
                setLoadingMessage('Successfully updated your subscription, redirecting back to your account page. Please wait...');
                setTimeout(function () {
                    push(response.redirect_url);
                    window.location.href = response.redirect_url
                }, 1000);
            });
        } else {
            setLoader(true);
            setLoadingMessage('Loading Checkout...');
            setTimeout(function () {
                window.location.href = '/checkout';
                push('/checkout');
                refresh();
            }, 1000);
        }
    }

    // Must have quote items to proceed.
    if (basketData !== null
        && typeof basketData !== 'undefined'
        && basketData?.items.length > 0
        && disabled === true) {
        setDisabled(false);
    }

    useEffect(() => {
        if (!basket.data.shopify_entrant && basket.data.is_sub_update === true) {
            setCheckoutMethod('update');
        } else if (basket.data.is_shopify_entrant && basket.data.logged_in
            && basket.data.consultation === false && basket.data.non_prescription === false) {
            setCheckoutMethod('shopify_entrant_no_consult');
        } else if (basket.data.is_shopify_entrant && !basket.data.logged_in) {
            setCheckoutMethod('shopify_entrant');
        }
    }, [basket]);

    return <div className="checkout-action">
        {checkoutMethod === 'update' && (
            <div className="update-notice">
                <strong>Please note:</strong> Changing your billing frequency, will trigger an immediate charge on your payment method, and a new order shipped out to your address.
            </div>
            )}
        <div className="checkout-button-wrapper">
            <button variant="contained" color="primary" className="button" disabled={disabled} onClick={() => checkout()}>
                {checkoutMethod === 'checkout' && !basket.data.has_active_sub && (
                    <span className="checkout-button-text">Checkout</span>
                )}
                {checkoutMethod === 'shopify_entrant_no_consult' && (
                    <span className="checkout-button-text">Complete consultation</span>
                )}
                {checkoutMethod === 'shopify_entrant' && !basket.data.logged_in && (
                    <span className="checkout-button-text">Register and Checkout</span>
                )}
                {checkoutMethod === 'shopify_entrant' && basket.data.logged_in && !basket.data.has_active_sub && (
                    <span className="checkout-button-text">Checkout</span>
                )}
                {checkoutMethod === 'update' && (
                    <span className="checkout-button-text">Update my subscription</span>
                )}
                {checkoutMethod === 'checkout' && basket?.data?.logged_in && basket?.data?.has_active_sub && (
                    <span className="checkout-button-text">Checkout</span>
                )}
            </button>
        </div>
    </div>
}

export default Checkout;